import React, { Component } from "react";
import UserDataInputComponent from "../components/booking/clientInformationComponent";
import BookingDateChoiceComponent from "../components/booking/dateChoiceComponent";
import BookingFinalizationComponent from "../components/booking/finalizatonComponent";
import BookingServiceChoiceComponent from "../components/booking/serviceChoiceComponent";
import BookingBarberChoiceComponent from "../components/booking/barberChoiceComponent";
import FooterComponent from "../components/footer/footerComponent";
import HeaderComponent from "../components/header/header";


class CreateBookingPageComponent extends Component {
    state = { 
        currentStep: 1,
        serviceChosen: "",
        barberChosen: "",
        dateChosen: 0,
        userData: null
    };

    componentDidMount() {
        // get request parameters if there are any (they will be present if user clicked on an email link)
        const searchParams = new URLSearchParams(window.location.search);
        const uslugaId = searchParams.get('usluga');
        let currentStep = 1;

        if(uslugaId === "sisanje" || uslugaId==="sisanjebrada" || uslugaId==="brada"){
            currentStep = 2;
        }
        this.setState({currentStep: currentStep, serviceChosen: uslugaId});
    }

    handleServiceChoice = (serviceChosenName) => {
        this.state.serviceChosen = serviceChosenName;
        this.state.currentStep = 2;
        this.setState({currentStep: 2});
    }

    handleBarberChoice = (barberChosenName) => {
        this.state.barberChosen = barberChosenName;
        this.state.currentStep = 3;
        this.setState({currentStep: 3});
    }

    handleDateChoice = (dateChosenValue) => {
        this.state.dateChosen = dateChosenValue;
        this.state.currentStep = 4;
        this.setState({currentStep: 4});
    }

    handleUserDataInput = (requestCreationStatus) => {
        this.state.bookingStatus = requestCreationStatus;
        this.state.currentStep = 5;
        this.setState({currentStep: 5});
        console.log(requestCreationStatus);
    }

    changeBarber = () => {
        this.setState({currentStep: 2, barberChosen: ""}); // Go back to barber choice and reset relevant state
    }

    getComponentForActiveStep(){
        if(this.state.currentStep===1) return <BookingServiceChoiceComponent onServiceChoice={this.handleServiceChoice}/>;
        else if(this.state.currentStep===2) return <BookingBarberChoiceComponent onBarberChoice={this.handleBarberChoice}/>;
        else if(this.state.currentStep===3) return <BookingDateChoiceComponent onDateChoice={this.handleDateChoice} barberChosen={this.state.barberChosen} onChangeBarber={this.changeBarber}/>;
        else if(this.state.currentStep===4) return <UserDataInputComponent onUserDataInput={this.handleUserDataInput} currentInformation={this.state}/>;
        else if(this.state.currentStep===5) return <BookingFinalizationComponent bookingStatus={this.state.bookingStatus}/>
        else return <BookingServiceChoiceComponent onServiceChoice={this.handleServiceChoice}/>;
    }

    render() { 
        return (
        <div>
            <HeaderComponent navBarMode="other"/>
            {this.getComponentForActiveStep()}
            <FooterComponent/>
        </div>);
    }
}
 
export default CreateBookingPageComponent;